var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.toastlist.length > 0)?_c('div',{staticClass:"toasts"},_vm._l((_vm.toastlist),function(item,index){return _c('span',{staticClass:"toast-item",class:{ 'fade-out': item.fadeOut },style:({ 'top': '-' + (0.3 * index) + 'rem'})},[_vm._v(_vm._s(item.text))])}),0):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// /home/g0/live-stream/web-client/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-76bd8396","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!/home/g0/live-stream/web-client/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/toasts.vue
// module id = null
// module chunks = 